import { ChevronLeft, ChevronRight } from "lucide-react";
import clsx from "clsx";

interface StepNavigationProps {
  onBack?: () => void;
  onNext?: () => void;
  nextLabel?: string;
  nextDisabled?: boolean;
  isLastStep?: boolean;
  isLoading?: boolean;
}

export default function StepNavigation({
  onBack,
  onNext,
  nextLabel = "Weiter",
  nextDisabled = false,
  isLastStep = false,
  isLoading = false,
}: StepNavigationProps) {
  return (
    <div className="flex gap-3 mt-6">
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          className="flex items-center gap-1 px-4 py-2.5 rounded-lg border border-neko-dark-3 text-neko-gray hover:text-neko-white hover:border-neko-gray transition-all text-sm font-medium"
          aria-label="Zurück"
        >
          <ChevronLeft className="w-4 h-4" />
          Zurück
        </button>
      )}
      {onNext && (
        <button
          type="button"
          onClick={onNext}
          disabled={nextDisabled || isLoading}
          className={clsx(
            "flex-1 flex items-center justify-center gap-2 py-2.5 px-4 rounded-lg font-bold text-sm transition-all",
            isLastStep
              ? "bg-neko-orange hover:bg-neko-orange-dark text-neko-dark"
              : "bg-neko-orange hover:bg-neko-orange-dark text-neko-dark",
            (nextDisabled || isLoading) && "opacity-60 cursor-not-allowed"
          )}
        >
          {nextLabel}
          {!isLastStep && <ChevronRight className="w-4 h-4" />}
        </button>
      )}
    </div>
  );
}
